<!--
  MapLocationInfo.vue
    Map Location Information Component
-->

<!-- -------------------------------------------------------------------------------- -->
<template>
  <div class="hm-mli-wrap" @click="onSelectLocationInfo($event, pLocationInfo)">
    <v-divider />
    <v-layout row wrap align-center justify-center>
      <v-flex xs4 sm2 md2 class="hm-ellipsis hm-mli-flex-wrap">
        {{ pLocationInfo.name }}
      </v-flex>
      <v-flex xs4 sm2 md2 class="hm-ellipsis hm-mli-flex-wrap hm-display-monitor">
        {{ groupName }}
      </v-flex>
      <v-flex xs5 sm6 md6 class="hm-mli-flex-wrap">
        <!-- ブラウザ版はツールチップ -->
        <v-tooltip bottom class="hm-ellipsis hm-display-monitor">
          <template slot="activator">
             {{ pLocationInfo.message }}
          </template>
          <p class="hm-mli-msg-tooltip">{{ pLocationInfo.message }}</p>
        </v-tooltip>
        <!-- スマホ版はクリックで表示 -->
        <span id="hm-mli-msg" class="hm-ellipsis hm-display-mobile">{{ pLocationInfo.message }}</span>
      </v-flex>
      <v-flex xs3 sm2 md2 class="hm-ellipsis hm-mli-flex-wrap hm-display-monitor">
        {{ pLocationInfo.send_time | formatTimestamp }}<br />
      </v-flex>
      <v-flex xs3 sm2 md2 class="hm-ellipsis hm-mli-flex-wrap hm-display-mobile">
        {{ pLocationInfo.send_time | formatDate }}<br />
        {{ pLocationInfo.send_time | formatTime }}
      </v-flex>
    </v-layout>
  </div>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>
import { mapState } from 'vuex'
import { isNullorUndefined, formatDateMoment } from '@/common'

export default {
  name: 'MapLocationInfo',
  props: [ 'pLocationInfo' ],
  data: () => ({
  }),
  components: {
  },
  mounted: function () {
    this.$log.debug('# MapLocationInfo')
  },
  destroyed: function () {
    this.$log.debug('# MapLocationInfo')
  },
  computed: {
    ...mapState({
      mUserList: state => state.sUserList,
      mGroupList: state => state.sGroupList,
    }),
    groupName: function () {
      const user_info = this.mUserList.find((elm) => {
        return (elm.staff_id.toString() === this.pLocationInfo.staff_id.toString())
      })
      if (isNullorUndefined(user_info)) {
        return ''
      }
      const group = this.mGroupList.find((elm) => {
        return (elm.group_id.toString() === user_info.group_id.toString())
      })
      if (isNullorUndefined(group)) {
        return ''
      }

      return group.g_name
    }
  },
  filters: {
    formatTimestamp: function (time) {
      if (isNullorUndefined(time) || time === '') {
        return ''
      }
      return formatDateMoment(time, 'YYYY-MM-DD HH:mm:ss')
    },
    formatDate: function (time) {
      if (isNullorUndefined(time) || time === '') {
        return ''
      }
      return formatDateMoment(time, 'YYYY-MM-DD')
    },
    formatTime: function (time) {
      if (isNullorUndefined(time) || time === '') {
        return ''
      }
      return formatDateMoment(time, 'HH:mm:ss')
    },
  },
  methods: {
    // -------------------------------------------------------------------------
    onSelectLocationInfo: function (event, locationInfo) {
      let msgPopup = false
      if (event.target.id === 'hm-mli-msg') {
        // クリックした場所がメッセージ列の場合
        let offsetW = event.target.offsetWidth  // メッセージ欄の幅
        let scrollW = event.target.scrollWidth  // メッセージを全文表示した場合の幅
        if (offsetW < scrollW) {
          // 表示する文字列が表示領域の幅を超過している場合
          // クリックでポップアップダイアログを表示できるように設定
          msgPopup = true
        }
      }
      this.$emit('locationInfoSelected', locationInfo, msgPopup)
    },
  }
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
.hm-mli-wrap:hover {
  background-color: #eeeeee;
}

.hm-mli-flex-wrap {
  padding: 5px 10px 5px 0px;
  font-size: 0.8em;
}
@media screen and (min-width: 601px) {
.hm-mli-flex-wrap {
  font-size: 1em;
}
}
.hm-mli-msg-tooltip {
  max-width: 250px;
  overflow-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/MapLocationInfo.vue